<app-header></app-header>
<header class="slidermain menu-page text-white thanku-page"> 
    <img src="assets/img/thanku-bg.jpg" alt="news" class="w-100">
     <div class="container-fluid">
         <div class="mask-content-v-center text-left">
                   <div class="row align-items-center">
                      
                    <div class="col-md-5 h-100  thanku-tbox-left">
                      <div class="border-out  offset-md-2 text-center">
                       
                        <div class="right-check"> <i class="fas fa-check"></i> </div> 
                        <h3 class="thanku-heading">{{ 'thankyou.thanks' | translate }}, {{this.userName}} !</h3>
                        <div class="divider">
                           <span class="border"></span>
                          </div>
                          <p class="b-text">{{ 'thankyou.order_sent' | translate }}</p>
                        <a class="download bckhpage-btn"  href="/" >{{ 'thankyou.back_home' | translate }}</a>
                        
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-1  thanku-tbox-right">

                     
                       <div class="divider">
                        <span class="border"></span> 
                        <span class="dot-txt">{{ 'thankyou.order_info' | translate }}</span>
                        <span class="border"></span>
                       </div>
                       
                        <ul class="list-group order-info-box">
                              <li class="list-group-item">{{ 'ord_detail.ord_no' | translate }} :<span> {{order_id}}</span></li>
                              <li class="list-group-item">{{ 'ord_detail.amount' | translate }} :<span> AED {{netpaid}}</span></li>
                              <li class="list-group-item">{{ 'myaccount.order_date' | translate }} :<span>{{order_date}}</span></li>
                              <li class="list-group-item" *ngIf="scheduleDate"> {{ 'thankyou.delivery_date_time' | translate }} :<span>{{scheduleDate}}</span></li>
                              <li class="list-group-item">{{ 'ord_detail.pay_mode' | translate }}:<span *ngIf="showLang == 'en' " > {{payment_method}}</span> <span *ngIf="showLang == 'ar' "> {{payMentMethod_ar}}</span> </li>
                        </ul>
                    </div>
                   </div>
                   
                </div>
     </div>
</header>
